import { styled } from '@mui/material';
import MuiInput, { InputProps as MuiInputProps } from '@mui/material/Input';
import * as React from 'react';
import { AiFillMinusCircle } from 'react-icons/ai';

export type InputProps = {
    label?: string,
    helperText?: string,
    type?: string,
    errorText?: string,
    maxChars?: number,
    collapse?: boolean,
} & MuiInputProps;

const StyledTextFieldContainer = styled('div')(() => ({
    'display': 'flex',
    'fontFamily': '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
    'flexDirection': 'column',
    'width': 'initial',
    'input': { padding: '0 !important' }
}));

const StyledInfosContainer = styled('div')({
    'marginBottom': '6px',
    'display': 'flex',
    'flexDirection': 'column'
});

const StyledHelperTextContainer = styled('span')(({ disabled }: Partial<InputProps>) => ({
    'fontSize': "12px",
    'color': disabled ? '#C1C1C4' : "#9DA6AD",
    'lineHeight': "12px",
    'fontFamily': "Roboto",
    'fontWeight': 400,
    'textAlign': "left"
}));

const StyledLabelContainer = styled('span')(({ disabled, readOnly }: Partial<InputProps>) => ({
    'fontSize': "14px",
    'color': readOnly ? "black" : disabled ? "#9DA6AD" : "#152935",
    'letterSpacing': "0",
    'lineHeight': "14px",
    'fontFamily': "Roboto !important",
    'fontWeight': 700,
    'textAlign': "left",
    'marginBottom': '0px',
    'marginLeft': 2
}));

export const StyledInput = styled(MuiInput, { shouldForwardProp: (props: any) => props } as any)(({ disabled, readOnly, error }: any) => ({
    'border': disabled ? '1px solid #C1C1C4' : readOnly ? '1px solid #C1C1C4' : error ? '1px solid #D82829' : '1px solid #C9D9E8',
    'backgroundColor': (disabled || readOnly) ? '#FAFBFD' : '#F2F5F8',
    'padding': '7.5px 14px!important',
    'fontFamily': "Roboto !important",
    'cursor': disabled ? 'not-allowed!important' : 'text!important',
    '*': {
        'cursor': disabled ? 'not-allowed!important' : 'text!important'
    },
    ':hover': {
        'border': disabled ? '1px solid #0090D1' : readOnly ? '1px solid #C1C1C4' : error ? '1px solid #D82829' : '1px solid #0090D1!important'
    },
    '::placeholder': {
        color: "rgb(193, 193, 196)",
        fontSize: "14px",
        fontFamily: "Roboto-Regular",
        fontWeight: "normal",
        letterSpacing: "0.25px",
        lineHeight: "20px"
    },
    '::before': {
        'all': 'unset'
    },
    '::after': {
        'all': 'unset'
    }
}));

const StyledErrorContainer = styled('span')({
    'fontSize': "13px",
    'color': "#D82829",
    'lineHeight': "18px",
    'fontWeight': 400,
    'fontFamily': "Roboto !important",
    'display': 'flex',
    'alignItems': 'center',
    'textAlign': "left"
});

export const VdsTextField: React.VFC<InputProps> = (props) => {

    const {
        label,
        errorText,
        helperText,
        collapse,
        error,
        ...inputProps
    } = props;

    return (
        <StyledTextFieldContainer sx={{
            ...inputProps.sx,
            'minHeight': collapse ? 'unset' : '80px'
        }}>
            {(label || helperText) && (
                <StyledInfosContainer>
                    {label && (
                        <StyledLabelContainer>
                            {label}
                        </StyledLabelContainer>
                    )}
                    {helperText && (
                        <StyledHelperTextContainer disabled={props?.disabled}>
                            {helperText}
                        </StyledHelperTextContainer>
                    )}
                </StyledInfosContainer>
            )}
            <StyledInput
                {...inputProps}
                error={error}
                sx={{
                    '.MuiTouchRipple-root': { cursor: 'pointer!important' },
                    button: { cursor: 'pointer!important' },
                    svg: { cursor: 'pointer!important' },
                    ...inputProps.sx
                }}
            />
            {error && (
                <StyledErrorContainer>
                    <AiFillMinusCircle size={13} style={{ marginLeft: 6, marginRight: 6 }} /> {errorText}
                </StyledErrorContainer>
            )}
        </StyledTextFieldContainer>
    );
}